import React, { FC, ReactNode } from 'react';

import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import {
  getOrCreateGlobalContext,
  useContextWithValidation,
} from '@adsk/alloy-react-context';

import {
  usePluginResolver,
  UsePluginResolverReturnType as ReferencePickerPluginsContextValue,
} from '../hooks/usePluginResolver';
import { ResolvableCommonReferencePickerPlugin } from '../types/types';

export interface ReferencePickerPluginsContextProp {
  children: ReactNode | ReactNode[];
  plugins: ResolvableCommonReferencePickerPlugin[];
  onPluginsLoadError?: (error: unknown[]) => void;
}

const ReferencePickerPluginsContext =
  getOrCreateGlobalContext<ReferencePickerPluginsContextValue>(
    CONTEXT_NAMES.ReferencePickerPluginsContext,
  );

export const useReferencePickerPlugins = () =>
  useContextWithValidation(ReferencePickerPluginsContext, {
    hook: 'useReferencePickerPlugins',
    provider: 'ReferencePickerPluginsProvider',
  });

const ReferencePickerPluginsProvider: FC<ReferencePickerPluginsContextProp> = ({
  children,
  plugins: pluginsFromProp,
  onPluginsLoadError,
}) => {
  const { plugins, allowedPlugins, loadingPlugins } = usePluginResolver(
    pluginsFromProp,
    onPluginsLoadError,
  );

  return (
    <ReferencePickerPluginsContext.Provider
      value={{
        plugins,
        loadingPlugins,
        allowedPlugins,
      }}
    >
      {children}
    </ReferencePickerPluginsContext.Provider>
  );
};

ReferencePickerPluginsProvider.displayName = 'ReferencePickerPluginsProvider';

export default ReferencePickerPluginsProvider;
